import { apiRoutes } from "@constants/api-routes";
import { handleRequestWithBody } from "@utils/http-util";
import { injectIdentityProviderIdAndChangeRequestStatus } from "@utils/parameter-injector";
import { RequestTypes } from "@enums/request-types";
import { ChangeRequestStatusTypes } from "@enums/change-request-status-types";
import { IdentityProviderChangeRequestResponse } from "@idw-types/data/identity-providers";

type UpdateIdentityProviderChangeRequestRequestResponse = {
    transferObject: IdentityProviderChangeRequestResponse;
};

export const updateIdentityProviderChangeRequestRequest = async (
    identityProviderId: string,
    body: { [key: string]: any },
    changeRequestStatus: ChangeRequestStatusTypes
): Promise<{ data: UpdateIdentityProviderChangeRequestRequestResponse, error: any }> => {
    const route = injectIdentityProviderIdAndChangeRequestStatus(apiRoutes.idpConfiguration.identityProviderConfig.changeRequest.identityProvider.updateChangeRequest, identityProviderId, changeRequestStatus);
    const { data, error } = await handleRequestWithBody(RequestTypes.PUT, route, body);
    return { data, error };
};